import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import WithAppTopContexts from "../common/components/with_app_top_contexts";
import { addProtection } from '../../../common/imageProtection';
import store from './store.js';
import Index from './components/index.js';

const App = (props) => {
  useEffect(() => {
    return addProtection();
  }, []);

  return (
    <Provider store={ store }>
      <WithAppTopContexts initProps={ props }>
        <Index { ...props } />
      </WithAppTopContexts>
    </Provider>
  );
};

export default App;
